<div class="set-match-score-container">
    <h2>Registrar resultado</h2>
    <div style="text-align: center;">
      <strong>{{ data.match.player1.playerName }}</strong> vs <strong>{{ data.match.player2.playerName }}</strong>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <div formArrayName="games">
        <div class="game-score" *ngFor="let game of games.controls; let i = index" [formGroupName]="i">
          <h4>Game {{ i + 1 }}</h4>

          <mat-form-field appearance="fill">
            <!-- <mat-label>{{ data.player1Id }}</mat-label> -->
            <input matInput type="number" formControlName="player1Points" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <!-- <mat-label>{{ data.player2Id }}</mat-label> -->
            <input matInput type="number" formControlName="player2Points" />
          </mat-form-field>
        </div>
      </div>

      <div class="buttons">
            <button mat-flat-button color="primary" type="submit">Guardar resultado</button>
            <button matButton="outlined" type="button" (click)="exit()">Salir</button>
        </div>

    </form>
</div>